export default __webpack_public_path__ + "static/media/Gyre of the Sundered Skies.b4df142c.jpg";